// in src/posts.js
import React, { useEffect, useState } from 'react';
import { Filter, DateField, RichTextField, SimpleShowLayout, Show, ShowButton, SimpleList, BooleanInput, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput, ShowView, useRecordContext } from 'react-admin';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TextFieldFrom from '@mui/material/TextField';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getAuthApp } from '../services/security/authApp';
import Constants from '../shared/constants';
import Popup from 'reactjs-popup';
import { useMediaQuery, CardActions } from '@mui/material';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';

import { MenuItem } from '@mui/material';

//import DateTimePicker from 'material-ui/DateTimePicker';

//Utils
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import Autocomplete from '@mui/material/Autocomplete';
import Alert from '@mui/material/Alert';

//material-ui table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { format, subHours, parseISO, isValid } from 'date-fns';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const FiltrarCupones = (props) => (
    <Filter {...props}>
        <TextInput source="porcentaje_descuento" alwaysOn />
    </Filter>
);

const handleExportExcelCupones = () => {
    try {
        const authToken = getAuthApp();

        const headers = new Headers();
        headers.append('Authorization', `${authToken}`);

        const downloadURL = Constants.general.serverURL + "/api/cupones/csvexport/xmls";

        fetch(downloadURL, {
            method: 'GET',
            headers: headers
        })
            .then(response => {
                if (response.ok) {
                    response.blob().then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = 'Cupones.xlsx';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);
                    });
                } else {
                    throw new Error('Error al descargar el archivo');
                }
            })
            .catch(error => {
                console.error(error);
            });
    } catch (error) {
        console.error(error);
    }
};

const ActionsListCupones_Reportes = () => {
    return (
        <CardActions style={cardActionStyle}>
            <Button
                variant="contained"
                color="primary"
                onClick={handleExportExcelCupones}
            >
                Exportar Excel
            </Button>
        </CardActions>
    );
};


const DatagridWithFormattedDate = ({ source }) => {
    const record = useRecordContext();    

    if (!record || !record[source]) {
        return <span>Fecha Inválida</span>;
    }

    const fechaHoraInicio = parseISO(record[source]);
    if (!isValid(fechaHoraInicio)) {
        return <span>Fecha Inválida</span>;
    }
    const fechaHoraInicioRestada = subHours(fechaHoraInicio, -5);
    const formattedDateTime = format(fechaHoraInicioRestada, 'yyyy-MM-dd, HH:mm:ss.SSS');
    return <span>{formattedDateTime}</span>;
};

const DatagridWithFormattedDateFin = ({ source }) => {
    const record = useRecordContext();    

    if (!record || !record[source]) {
        return <span>Fecha Inválida</span>;
    }

    const fechaHoraFinal = parseISO(record[source]);
    if (!isValid(fechaHoraFinal)) {
        return <span>Fecha Inválida</span>;
    }
    const fechaHoraInicioRestada = subHours(fechaHoraFinal, -5);
    const formattedDateTime = format(fechaHoraInicioRestada, 'yyyy-MM-dd, HH:mm:ss.SSS');
    return <span>{formattedDateTime}</span>;
};


export const ListaCupones = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));  


    return (
        <List {...props} title="Cupones De Descuento" actions={<ActionsListCupones_Reportes />} filters={<FiltrarCupones />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.title}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="nombre_cupon" label="Nombre Cupón" />
                    <TextField source="porcentaje_descuento" label="% Descuento" />
                    <DatagridWithFormattedDate source="fecha_hora_inicio" label="Fecha y Hora Inicio" showTime />
                    <DatagridWithFormattedDateFin source="fecha_hora_final" label="Fecha y Hora Fin" showTime />
                    <TextField source="numero_cupones_redimir" label="Cupones a Redimir" />
                    <TextField source="numero_cupones_redimidos" label="Cupones Redimidos" />
                    <TextField source="numero_cupones_disponibles" label="Cupones Disponibles" />
                    <ShowButton label="Producto" />
                    <TextField source="estado_cupon" label="Estado" />
                    <EditButton />                    
                </Datagrid>
            )}
        </List>
    );
};

const TituloCupones = ({ record }) => {
    return <span>Cupones de Descuento{record ? `"${record.title}"` : ''}</span>;
};


export const EditarCupones = (props) => {
    //estado del cupon despues de consultado
    const [estadoCupon, setEstadoCupon] = useState('');
    const [estadoNuevoCupon, setEstadoNuevoCupon] = useState('');
    const [estadoConsultaCupon, setEstadoConsultaCupon] = useState('');
    const [selectedNoFraccionesMinimas, setSelectedNoFraccionesMinimas] = useState('');
    const [selectedNoFraccionesMaximas, setSelectedNoFraccionesMaximas] = useState('');
    //estados para el op up
    const [showMessage, setShowMessage] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const [showConfirmationActulizar, setShowConfirmationActulizar] = useState(false);
    const [showConfirmationActulizacion, setShowConfirmationActulizacion] = useState(false);

    const [mensageServicio, setMensageServicio] = useState("");
    const [fechaFinal, setfechaFinal] = useState("");
    const [cuponesDisponibles, setcuponesDisponibles] = useState("");
    const fechaActual = new Date();

    const [noFraccionesMinimas, setNoFraccionesMinimas] = useState('');
    const [errorNoFraccionesMinimas, setErrorNoFraccionesMinimas] = useState('');

    const [noFraccionesMaximas, setNoFraccionesMaximas] = useState('');
    const [errorNoFraccionesMaximas, setErrorNoFraccionesMaximas] = useState('');


    //variable que retorna el id editar
    const params = useParams();
    const id = params.id;
    const idEsatadoCupon = params.estado_cupon;
    let values = [{}];
    values = {
        "id": id
    };

    const handleConfirmationActulizacionNo = () => {
        setShowConfirmationActulizacion(false);
    };

    const handleConfirmationNo = () => {
        setShowConfirmation(false);
    };

    const handleConfirmationYes = () => {
        setShowConfirmation(false);
    
        const minFracciones = selectedNoFraccionesMinimas ? parseInt(selectedNoFraccionesMinimas) : noFraccionesMinimas;
        const maxFracciones = selectedNoFraccionesMaximas ? parseInt(selectedNoFraccionesMaximas) : noFraccionesMaximas;
    
        if (estadoNuevoCupon !== estadoCupon ||
            minFracciones !== noFraccionesMinimas ||
            maxFracciones !== noFraccionesMaximas) {
            actualizarEstadoCupon();
        } else {
            setMensageServicio("No se realizó ninguna modificación en el cupón.");
            setShowMessage(true);
        }
    
        async function actualizarEstadoCupon() {
            try {
                const authToken = getAuthApp();
                const headers = new Headers();
                headers.append('Content-Type', 'application/json');
                headers.append('Authorization', `${authToken}`);
                const url = `${Constants.general.serverURL}/api/cupones/post-edit-state`;
                const body = {
                    coupon: values, 
                    state: estadoNuevoCupon,
                    noFraccionesMinimas: minFracciones,
                    noFraccionesMaximas: maxFracciones
                };
                    console.warn('BODY', JSON.stringify(body));
                const response = await fetch(url, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({ confisys: body }, null, 2)
                });
    
                if (response.ok) {
                    const responseData = await response.json();
                    const responseMessage = responseData.req;
                    setMensageServicio(responseMessage.message);
                    setShowMessage(true);
                } else {
                    setMensageServicio('Error al actualizar estado cupón');
                    setShowMessage(true);
                }
            } catch (error) {
            }
        }
    };
    
    //validacion de que se traiga el id del editar 
    if (!id) {
        alert("Se realizó un error en el sistema recargué la página de Nuevo");
    } else {
        //cargar el estado de id selecionado
        const consultarEstadoCupon = async () => {
            try {
                const authToken = getAuthApp();
                const headers = new Headers();
                headers.append('Content-Type', 'application/json');
                headers.append('Authorization', `${authToken}`);
                const url = `${Constants.general.serverURL}/api/cupones/post-consult-state`;
                const body = {
                    coupon: values

                };
                console.warn('BODY', JSON.stringify(body));
                const response = await fetch(url, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({ confisys: body }, null, 2)
                });
                if (response.ok) {
                    const responseData = await response.json();
                    const responseMessage = responseData.req;
                    setfechaFinal(responseMessage.body.fecha_hora_final);
                    setcuponesDisponibles(responseMessage.body.numero_cupones_disponibles);
                    if (responseMessage.body.estado_cupon === "ACTIVO") {
                        setEstadoCupon('ACTIVO');
                        setEstadoConsultaCupon('ACTIVO');
                    } else {
                        setEstadoCupon('INACTIVO');
                        setEstadoConsultaCupon('ACTIVO');
                    }
                    setNoFraccionesMinimas(responseMessage.body.numeroFraccionesMinimas);
                    setNoFraccionesMaximas(responseMessage.body.numeroFraccionesMaximas);


                } else {
                    throw new Error('Error al consultar estado cupón');
                }
            } catch (error) {
                console.error(error);
            }
        }
        consultarEstadoCupon();
    }
    //cargar los estados selecionados 
    const handleEstadoCuponChange = (event, value) => {
        setEstadoNuevoCupon(value);
    };
    const handleNumeroFraccionesMinimas = (event) => {
        const value = event.target.value;
        setSelectedNoFraccionesMinimas(value);
    };
    const handleNumeroFraccionesMaximas = (event) => {
        const value = event.target.value;
        setSelectedNoFraccionesMaximas(value);
    };

    const handleOnchengeEdit = (e) => {
        e.preventDefault(); 

        if (parseInt(selectedNoFraccionesMinimas) > parseInt(selectedNoFraccionesMaximas)) {
            setErrorNoFraccionesMinimas({
                error: true,
                message: "El número de fracciones mínimas no puede ser mayor que el número de fracciones máximas."
            });
        } else {
            setErrorNoFraccionesMinimas({
                error: false,
                message: ''
            });
            setShowConfirmation(true); // Mostrar el diálogo de confirmación solo cuando sea necesario
        }
    };
    return (
        <Edit  {...props} title="Editar Estado Cupón">
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '20px', paddingTop: '20px' }}>
                <Box
                    sx={{
                        display: 'grid',
                        gap: 1,
                        gridTemplateColumns: 'repeat(2, 1fr)',
                    }}
                    component="form"
                    onSubmit={handleOnchengeEdit}
                >
                    <Autocomplete
                        defaultValue={estadoCupon ? estadoCupon : estadoConsultaCupon}
                        onChange={handleEstadoCuponChange}
                        options={estados}
                        sx={{ width: 300 }}
                        id="controllable-states-demo"
                        renderInput={(params) => (
                            <TextFieldFrom
                                {...params}
                                placeholder={estadoCupon}
                            />
                        )}
                    />
                    <TextFieldFrom
                        select
                        label="No. Fracciones Mínimas*"
                        placeholder="No. Fracciones Mínimas*"
                        variant="outlined"
                        value={selectedNoFraccionesMinimas ? selectedNoFraccionesMinimas : noFraccionesMinimas}  // Usa el estado local para el valor
                        helperText={errorNoFraccionesMinimas.message}
                        onChange={handleNumeroFraccionesMinimas}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        sx={{ width: 300 }} // Centra el TextField horizontalmente
                    >
                        {[...Array(11).keys()].map(num => (
                            <MenuItem key={num} value={num}>
                                {num}
                            </MenuItem>
                        ))}
                    </TextFieldFrom>

                    <TextFieldFrom
                        select
                        label="No. Fracciones Máximas*"
                        placeholder="No. Fracciones Máximas*"
                        variant="outlined"
                        value={selectedNoFraccionesMaximas ? selectedNoFraccionesMaximas : noFraccionesMaximas}  // Usa el estado local para el valor
                        helperText={errorNoFraccionesMaximas.message}
                        onChange={handleNumeroFraccionesMaximas}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        sx={{ width: 300 }} // Centra el TextField horizontalmente
                    >
                        {[...Array(11).keys()].map(num => (
                            <MenuItem key={num} value={num}>
                                {num}
                            </MenuItem>
                        ))}
                    </TextFieldFrom>
                    <Dialog
                        open={showConfirmation}
                        onClose={handleConfirmationNo}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Editar Cupón"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                ¿Está seguro de cambiar el estado  {estadoCupon}?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleConfirmationNo}>No</Button>
                            <Button onClick={handleConfirmationYes} autoFocus>Sí</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={showConfirmationActulizacion}
                        onClose={handleConfirmationActulizacionNo}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Editar Cupón?"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                No es posible activar el Cupón, valide la información vigente
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleConfirmationActulizacionNo}>OK</Button>
                        </DialogActions>
                    </Dialog>
                    {showMessage && (
                        <Alert severity="success">{mensageServicio}</Alert>
                    )}
                    <Button
                        type="submit"
                        variant="outlined"
                        sx={{ mt: 2 }}>
                        Editar
                    </Button>
                </Box>
            </div>
        </Edit>
    );
};

export const PopupExample = () => {
    return (<Popup trigger={<button>Trigger</button>} position="right center">
        <div>Popup content here !!</div>
    </Popup>);
};

export const CrearCupones = (props) => {
    // Estados del formulario
    const [nombreCupon, setNombreCupon] = useState('');
    const [porcentajeCupon, setPorcentajeCupon] = useState('');
    const [fechaHoraInicio, setFechaHoraInicio] = useState(dayjs());
    const [fechaHoraFinal, setFechaHoraFinal] = useState(dayjs());
    const [numeroCuponesRedimir, setNumeroCuponesRedimir] = useState('');
    const [producto, setProducto] = useState([]);
    const [loterias, setLoterias] = useState([]);
    const [productoLoteria, setProductoLoteria] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showMessage, setShowMessage] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [mensageServicio, setMensageServicio] = useState('');

    // Estados de validación
    const [errorNombreCupon, setErrorNombreCupon] = useState({ error: false, message: '' });
    const [errorPorcentajeCupon, setErrorPorcentajeCupon] = useState({ error: false, message: '' });
    const [errorFechaHoraInicio, setErrorFechaHoraInicio] = useState({ error: false, message: '' });
    const [errorFechaHoraFinal, setErrorFechaHoraFinal] = useState({ error: false, message: '' });
    const [errorNumeroCuponesRedimir, setErrorNumeroCuponesRedimir] = useState({ error: false, message: '' });
    const [errorProducto, setErrorProducto] = useState({ error: false, message: '' });

    const todos = [{
        abreviatura: 'TODOS',
        desLoteria: 'TODOS',
        ideClaseLoteria: 0,
        ideLoteria: 0,
        ideProducto: 0,
    }];

    const handleConfirmationNo = () => setShowConfirmation(false);

    const handleConfirmationYes = async () => {
        setShowConfirmation(false);
        if (fechaHoraFinal.isBefore(fechaHoraInicio)) {
            alert('La fecha final debe ser mayor o igual a la fecha inicial');
            return;
        }
        
        const values = {
            nombre_cupon: nombreCupon,
            porcentaje_descuento: porcentajeCupon,
            fecha_hora_inicio: fechaHoraInicio.toISOString(),
            fecha_hora_final: fechaHoraFinal.toISOString(),
            numero_cupones_redimir: numeroCuponesRedimir,
            producto: producto,
            todos_productos: producto.length === loterias.length ? todos : [],
            createdAt: fechaHoraInicio.toISOString(),
            updatedAt: fechaHoraInicio.toISOString(),
        };

        try {
            const authToken = getAuthApp();
            const headers = new Headers({
                'Content-Type': 'application/json',
                'Authorization': `${authToken}`,
            });
            const url = `${Constants.general.serverURL}/api/cupones/post-create-coupon`;

            const response = await fetch(url, {
                method: 'POST',
                headers,
                body: JSON.stringify({ confisys: { coupon: values, activity: 'createCoupon' } }, null, 2),
            });

            if (response.ok) {
                const responseData = await response.json();
                setMensageServicio(responseData.req.message);
                setShowMessage(true);
            } else {
                setMensageServicio('Error al crear el cupón');
                setShowMessage(true);
            }
        } catch (error) {
            console.error(error);
            setMensageServicio('Error de conexión con el servidor');
            setShowMessage(true);
        }
    };

    const handleOnChange = (e) => {
        e.preventDefault();
        let isValid = true;

        if (!nombreCupon) {
            setErrorNombreCupon({ error: true, message: 'Nombre del cupón es requerido' });
            isValid = false;
        } else {
            setErrorNombreCupon({ error: false, message: '' });
        }

        if (!porcentajeCupon) {
            setErrorPorcentajeCupon({ error: true, message: 'Porcentaje de descuento es requerido' });
            isValid = false;
        } else {
            setErrorPorcentajeCupon({ error: false, message: '' });
        }

        if (!fechaHoraInicio) {
            setErrorFechaHoraInicio({ error: true, message: 'Fecha de inicio es requerida' });
            isValid = false;
        } else {
            setErrorFechaHoraInicio({ error: false, message: '' });
        }

        if (!fechaHoraFinal) {
            setErrorFechaHoraFinal({ error: true, message: 'Fecha final es requerida' });
            isValid = false;
        } else {
            setErrorFechaHoraFinal({ error: false, message: '' });
        }

        if (!numeroCuponesRedimir) {
            setErrorNumeroCuponesRedimir({ error: true, message: 'Número de cupones a redimir es requerido' });
            isValid = false;
        } else {
            setErrorNumeroCuponesRedimir({ error: false, message: '' });
        }

        if (producto.length === 0) {
            setErrorProducto({ error: true, message: 'Debe seleccionar al menos un producto' });
            isValid = false;
        } else {
            setErrorProducto({ error: false, message: '' });
        }

        if (isValid) setShowConfirmation(true);
    };

    useEffect(() => {
        const fetchLoterias = async () => {
            try {
                const authToken = getAuthApp();
                const headers = new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `${authToken}`,
                });
                const url = `${Constants.general.serverURL}/api/Users/etn/consultar-loterias-disponibles`;

                const response = await fetch(url, {
                    method: 'POST',
                    headers,
                    body: JSON.stringify({ lottery: { evento: null, fecha: '11-04-2018' } }, null, 2),
                });

                if (response.ok) {
                    const responseData = await response.json();
                    const loteriasData = responseData.data;
                    const todasLoterias = [...loteriasData];
                    const loteriasWithAllOption = [todos[0], ...loteriasData];
                    setLoterias(loteriasWithAllOption);
                    setLoading(false);
                } else {
                    throw new Error('Error al obtener las loterías');
                }
            } catch (error) {
                console.error(error);
            }
        };
        fetchLoterias();
    }, []);

    return (
        <Create {...props} title="Crear Cupón">
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '20px' }}>
                <Box
                    sx={{
                        display: 'grid',
                        gap: 1,
                        gridTemplateColumns: 'repeat(2, 1fr)',
                    }}
                    component="form"
                    onSubmit={handleOnChange}
                >
                    <TextFieldFrom
                        label="Nombre Cupón*"
                        type="text"
                        name="nombreCupon"
                        variant="outlined"
                        value={nombreCupon}
                        error={errorNombreCupon.error}
                        helperText={errorNombreCupon.message}
                        onChange={(e) => setNombreCupon(e.target.value)}
                        inputProps={{ maxLength: 30 }}
                    />
                    <TextFieldFrom
                        label="Porcentaje Descuento*"
                        type="number"
                        name="porcentajeCupon"
                        variant="outlined"
                        value={porcentajeCupon}
                        error={errorPorcentajeCupon.error}
                        helperText={errorPorcentajeCupon.message}
                        onChange={(e) => setPorcentajeCupon(e.target.value)}
                        inputProps={{ maxLength: 2 }}
                    />
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                            label="Fecha y Hora Inicio*"
                            value={fechaHoraInicio}
                            onChange={(newValue) => setFechaHoraInicio(newValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    error={errorFechaHoraInicio.error}
                                    helperText={errorFechaHoraInicio.message}
                                />
                            )}
                        />
                        <DateTimePicker
                            label="Fecha y Hora Fin*"
                            value={fechaHoraFinal}
                            onChange={(newValue) => setFechaHoraFinal(newValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    error={errorFechaHoraFinal.error}
                                    helperText={errorFechaHoraFinal.message}
                                />
                            )}
                        />
                    </LocalizationProvider>
                    <TextFieldFrom
                        label="Número de cupones a redimir*"
                        type="number"
                        name="numeroCuponesRedimir"
                        variant="outlined"
                        value={numeroCuponesRedimir}
                        error={errorNumeroCuponesRedimir.error}
                        helperText={errorNumeroCuponesRedimir.message}
                        onChange={(e) => setNumeroCuponesRedimir(e.target.value)}
                    />
                    <Autocomplete
                        multiple
                        id="productos"
                        options={loterias}
                        disableCloseOnSelect
                        loading={loading}
                        onChange={(event, newValue) => setProducto(newValue)}
                        getOptionLabel={(option) => option.desLoteria}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                {option.desLoteria}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Producto*"
                                variant="outlined"
                                error={errorProducto.error}
                                helperText={errorProducto.message}
                            />
                        )}
                    />
                </Box>
            </div>

            {showMessage && (
                <Dialog
                    open={showMessage}
                    onClose={() => setShowMessage(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Resultado de la operación"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {mensageServicio}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowMessage(false)} autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            <Dialog
                open={showConfirmation}
                onClose={handleConfirmationNo}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirmación"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        ¿Está seguro de que desea crear este cupón?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmationNo} color="primary">
                        No
                    </Button>
                    <Button onClick={handleConfirmationYes} color="primary" autoFocus>
                        Sí
                    </Button>
                </DialogActions>
            </Dialog>

            <Alert severity="info">Complete todos los campos requeridos para crear el cupón.</Alert>
        </Create>
    );
};

export const VistaCupones = (props) => {
    const [idLoteria, setIdLoteria] = useState([]);
    const [nombreLoteria, setNombreLoteria] = useState([]);
    const [loteriacupones, setLoteriaCupones] = useState([]);


    //variable que retorna el id editar
    const { id } = useParams();
    let values = [{}];
    values = {
        "idCupon": id
    };
    //consultar los id relacionados con el cupon
    const consultarIdLoteriaCupon = async () => {
        try {
            const authToken = getAuthApp();
            const headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', `${authToken}`);
            const url = `${Constants.general.serverURL}/api/cupones/post-consult-id-loteria-cupon`;
            const body = {
                coupon: values
            };
            console.warn('BODY', JSON.stringify(body));
            const response = await fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ confisys: body }, null, 2)
            });
            if (response.ok) {
                const responseData = await response.json();
                const responseMessage = responseData.req;
                setLoteriaCupones(responseMessage.body);
            } else {
                throw new Error('Error al consultar estado cupón');
            }
        } catch (error) {
            console.error(error);
        }
    }
    consultarIdLoteriaCupon();
    return (
        <Show {...props} title="Loterías Relacionadas con el Cupón" >
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '20px' }}>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>IdCupon</TableCell>
                                <TableCell>IdLotería</TableCell>
                                <TableCell align="right">Nombre Lotería </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loteriacupones.map((row) => (
                                <TableRow
                                    key={row.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.idCupon}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.idLoteria}
                                    </TableCell>
                                    <TableCell align="right">{row.nombreLoteria}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </Show>)
};


const estados = [
    "ACTIVO",
    "INACTIVO"
];
